import { EnvironmentProviders, makeEnvironmentProviders, PLATFORM_ID } from '@angular/core';
import { isPlatformBrowser } from '@angular/common';
import { ServicioRouterModyo } from '@core/services/modyo/modyo-router.service';
import { lastValueFrom } from 'rxjs';

export function inicializarRutasModyo(servicioRouter: ServicioRouterModyo, esNavegador: boolean): () => Promise<void> {
  return () => {
    if (!esNavegador) {
      return Promise.resolve();
    }

    return lastValueFrom(servicioRouter.cargarMapaRutas()).then(() => undefined);
  };
}

export function provideInicializacionRutasModyo(): EnvironmentProviders {
  return makeEnvironmentProviders([
    {
      provide: 'INIT_RUTAS_MODYO',
      useFactory: (servicioRouter: ServicioRouterModyo, platformId: object): (() => Promise<void>) => {
        const esNavegador = isPlatformBrowser(platformId);
        const initFn = inicializarRutasModyo(servicioRouter, esNavegador);
        initFn();
        return initFn;
      },
      deps: [ServicioRouterModyo, PLATFORM_ID],
      multi: true,
    },
  ]);
}
